import apiFetch from "../../../shared/services/apiClient";

// ── Notificaciones ────────────────────────────────────────────────────────────

export async function getNotificaciones() {
  const res = await apiFetch("/api/core/portal/notificaciones/");
  if (!res.ok) throw new Error("Error al cargar notificaciones");
  return res.json();
}

export async function marcarTodasLeidas() {
  await apiFetch("/api/core/portal/notificaciones/", { method: "PATCH" });
}

export async function marcarLeida(pk) {
  await apiFetch(`/api/core/portal/notificaciones/${pk}/`, { method: "PATCH" });
}

// ── Estado de cuenta ──────────────────────────────────────────────────────────

export async function getEstadoCuenta() {
  const res = await apiFetch("/api/core/portal/estado-cuenta/");
  if (!res.ok) throw new Error("Error al cargar estado de cuenta");
  return res.json();
}

// ── Áreas comunes ─────────────────────────────────────────────────────────────

export async function getAreas() {
  const res = await apiFetch("/api/core/portal/areas/");
  if (!res.ok) throw new Error("Error al cargar áreas");
  return res.json();
}

export async function createArea(formData) {
  const res = await apiFetch("/api/core/portal/areas/", { method: "POST", body: formData });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function updateArea(pk, formData) {
  const res = await apiFetch(`/api/core/portal/areas/${pk}/`, { method: "PATCH", body: formData });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function deleteArea(pk) {
  const res = await apiFetch(`/api/core/portal/areas/${pk}/`, { method: "DELETE" });
  if (!res.ok) throw new Error("Error al eliminar área");
}

// ── Horarios ──────────────────────────────────────────────────────────────────

export async function createHorario(data) {
  const res = await apiFetch("/api/core/portal/horarios/", {
    method: "POST",
    body: JSON.stringify(data),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function updateHorario(pk, data) {
  const res = await apiFetch(`/api/core/portal/horarios/${pk}/`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function deleteHorario(pk) {
  const res = await apiFetch(`/api/core/portal/horarios/${pk}/`, { method: "DELETE" });
  if (!res.ok) throw new Error("Error al eliminar horario");
}

// ── Disponibilidad ────────────────────────────────────────────────────────────

export async function getDisponibilidad(areaId, year, month) {
  const res = await apiFetch(`/api/core/portal/disponibilidad/?area=${areaId}&year=${year}&month=${month}`);
  if (!res.ok) throw new Error("Error al cargar disponibilidad");
  return res.json();
}

// ── Reservaciones ─────────────────────────────────────────────────────────────

export async function getReservaciones(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await apiFetch(`/api/core/portal/reservaciones/${qs ? "?" + qs : ""}`);
  if (!res.ok) throw new Error("Error al cargar reservaciones");
  return res.json();
}

export async function crearReservacion(formData) {
  const res = await apiFetch("/api/core/portal/reservaciones/", { method: "POST", body: formData });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function revisarReservacion(pk, payload) {
  const res = await apiFetch(`/api/core/portal/reservaciones/${pk}/`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function cambiarFechaReservacion(pk, nueva_fecha) {
  const res = await apiFetch(`/api/core/portal/reservaciones/${pk}/cambiar-fecha/`, {
    method: "PATCH",
    body: JSON.stringify({ nueva_fecha }),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function getCuentasIngreso() {
  const res = await apiFetch("/api/core/portal/cuentas-ingreso/");
  if (!res.ok) throw new Error("Error al cargar cuentas de ingreso");
  return res.json();
}

// Cuentas bancarias del condominio, para registrar dónde entró el pago de una
// reserva. El endpoint pagina de 8 en 8, así que se recorren todas las páginas.
export async function getCuentasBancarias() {
  const todas = [];
  for (let page = 1; page <= 20; page++) {
    const res = await apiFetch(`/api/finance/cuentaBancaria/?page=${page}`);
    if (!res.ok) { if (page === 1) throw new Error("Error al cargar cuentas bancarias"); break; }
    const d = await res.json();
    if (Array.isArray(d)) return d;
    todas.push(...(d.results || []));
    if (!d.next) break;
  }
  return todas;
}

export async function cancelarReservacion(pk) {
  const res = await apiFetch(`/api/core/portal/reservaciones/${pk}/`, {
    method: "PATCH",
    body: JSON.stringify({ estado: "CANCELADA" }),
  });
  if (!res.ok) throw new Error("Error al cancelar reservación");
}

export async function deleteReservacion(pk) {
  const res = await apiFetch(`/api/core/portal/reservaciones/${pk}/`, { method: "DELETE" });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.detail || "Error al eliminar la reservación"); }
}

// ── Avisos de pago ────────────────────────────────────────────────────────────

export async function getAvisosPago(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await apiFetch(`/api/core/portal/avisos-pago/${qs ? "?" + qs : ""}`);
  if (!res.ok) throw new Error("Error al cargar avisos de pago");
  return res.json();
}

export async function crearAvisoPago(formData) {
  const res = await apiFetch("/api/core/portal/avisos-pago/", { method: "POST", body: formData });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function revisarAvisoPago(pk, estado, notas_admin = "") {
  const res = await apiFetch(`/api/core/portal/avisos-pago/${pk}/`, {
    method: "PATCH",
    body: JSON.stringify({ estado, notas_admin }),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.detail || JSON.stringify(d)); }
  return res.json();
}

export async function deleteAvisoPago(pk) {
  const res = await apiFetch(`/api/core/portal/avisos-pago/${pk}/`, { method: "DELETE" });
  if (!res.ok) throw new Error("Error al eliminar aviso de pago");
}

// ── Avisos admin ──────────────────────────────────────────────────────────────

export async function getAvisos(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await apiFetch(`/api/core/portal/avisos/${qs ? "?" + qs : ""}`);
  if (!res.ok) throw new Error("Error al cargar avisos");
  return res.json();
}

export async function crearAviso(formData) {
  const res = await apiFetch("/api/core/portal/avisos/", { method: "POST", body: formData });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function deleteAviso(pk) {
  const res = await apiFetch(`/api/core/portal/avisos/${pk}/`, { method: "DELETE" });
  if (!res.ok) throw new Error("Error al eliminar aviso");
}

// ── Residentes ────────────────────────────────────────────────────────────────

export async function getResidentes() {
  const res = await apiFetch("/api/core/portal/residentes/");
  if (!res.ok) throw new Error("Error al cargar residentes");
  return res.json();
}

export async function crearResidente(data) {
  const res = await apiFetch("/api/core/portal/residentes/", {
    method: "POST",
    body: JSON.stringify(data),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function updateResidente(pk, data) {
  const res = await apiFetch(`/api/core/portal/residentes/${pk}/`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(JSON.stringify(d)); }
  return res.json();
}

export async function deleteResidente(pk) {
  const res = await apiFetch(`/api/core/portal/residentes/${pk}/`, { method: "DELETE" });
  if (!res.ok) throw new Error("Error al eliminar residente");
}

// ── Invitaciones y restablecer contraseña ────────────────────────────────────

async function _json(res, fallback) {
  const d = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(d.detail || fallback);
  return d;
}

export async function getInvitaciones() {
  return _json(await apiFetch("/api/core/portal/invitaciones/"), "Error al cargar invitaciones");
}

export async function crearInvitacion(filial_id, email) {
  return _json(await apiFetch("/api/core/portal/invitaciones/", {
    method: "POST",
    body: JSON.stringify({ filial_id, email }),
  }), "No se pudo crear la invitación");
}

/** Máximo 10 por llamada: el componente manda la selección en lotes. */
export async function invitarMasivo(items) {
  return _json(await apiFetch("/api/core/portal/invitaciones/masivo/", {
    method: "POST",
    body: JSON.stringify({ items }),
  }), "No se pudieron enviar las invitaciones");
}

export async function reenviarInvitacion(pk) {
  return _json(await apiFetch(`/api/core/portal/invitaciones/${pk}/reenviar/`, { method: "POST" }),
    "No se pudo reenviar la invitación");
}

export async function cancelarInvitacion(pk) {
  return _json(await apiFetch(`/api/core/portal/invitaciones/${pk}/`, { method: "DELETE" }),
    "No se pudo cancelar la invitación");
}

export async function enviarResetResidente(pk) {
  return _json(await apiFetch(`/api/core/portal/residentes/${pk}/enviar-reset/`, { method: "POST" }),
    "No se pudo enviar el enlace");
}
